<!-- Please don't depend on  
 -- As we are moving to tailwind css instead of nebular
 so you should never use nebular tags or attributes in this file or any other file
 as it will be removed in the future 
 
 1. this is the reason why things are moved inside the <nb-layout-column> tag
 2. we couldn't remove the nb-layout as if we did so the app will break on things that depend on nebular
 -->

<nb-layout [ngClass]="authService.user !== null && !authService.user['confirmed'] ? 'tw-pt-32' : ''">
  <nb-layout-column>
    <div class="tw-relative">
      @if(!publicMode && isLoggedIn){
      <div #navbar class="tw-fixed tw-top-0 tw-z-50 tw-w-full tw-overflow-visible" data-navbar-dropdown-host>
        <app-navbar> </app-navbar>
        @if(authService.user !== null && !authService.user['confirmed']){
        <div
          class="confirm-alert tw-px-2 tw-m-0 tw-h-7 tw-w-screen tw-start-0 tw-end-0 tw-bottom-0 tw-top-16 tw-rounded-none tw-flex tw-items-center tw-text-xs tw-leading-3 tw-bg-yellow-300"
        >
          <mat-icon class="tw-mx-2"> warning </mat-icon>
          Please confirm your email {{ authService.user.email }}. <a (click)="resendConfirmation()" class="tw-mx-1 tw-underline"> Resend confirmation</a>
        </div>
        }
      </div>
    }
    <div
      [style.top.px]="wizardTop"
      [style.height]="`calc(100vh - ${wizardTop}px)`"
      class="tw-fixed tw-left-0 tw-w-screen tw-z-[-1] tw-pointer-events-none"
      id="wizard__container"
    >
    </div>
      <div class="fb-customerchat" page_id="330351414098151"></div>
      <ng-template #dialog let-data let-ref="dialogRef">
        <div class="basics">
          <nb-card>
            <nb-card-header>
              <a class="float-right icon" (click)="ref.close()">
                <mat-icon style="cursor: pointer"> cancel </mat-icon>
              </a>
            </nb-card-header>
            <nb-card-body>
              <div class="container-fluid">
                <div class="row just-content-center">
                  <ngx-data-privacy *ngIf="popStatus === 'dpr'"></ngx-data-privacy>
                  <ngx-terms-and-conditions *ngIf="popStatus === 'tc'"></ngx-terms-and-conditions>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </ng-template>
      <div
        class="tw-z-10 tw-relative"
        [ngClass]="
          !publicMode && isLoggedIn
            ? authService.user !== null && !authService.user['confirmed']
              ? 'padding-top-92 md:padding-top-108 lg:padding-top-92'
              : 'tw-pt-16 md:tw-pt-20 lg:tw-pt-16'
            : ''
        "
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
